import styles from "./styles.module.css";
import { CameraIcon } from "@/icons/components/Camera";
import { PagegrowlerFunctions } from "@pagegrowler_nextjs";

const CLIPPING_THUMBNAIL = "3_2_300x200";

const ModuloContainerGaleriaNotas = (props) => {
    const { summary, title, url, images } = props;
    const pagegrowlerFunctions = PagegrowlerFunctions();

    const setImg = (element, clipping) => {
        const elementImg = {
            images: [
                element?.value && {
                    clippings: element.value.clippings || [],
                    title: element.value.title || ''
                }
            ]
        };
        return pagegrowlerFunctions.getFullImageObject(elementImg, clipping, process.env.NEXT_PUBLIC_IMAGE_DOMAIN);
    };

    const img = images?.[0] ? setImg(images[0], CLIPPING_THUMBNAIL) : { url: '' };

    return (
        <div className={styles["nota-container"]}>
            <a href={url} className={styles["url-nota-container"]} />
            <div className={`${styles["img-container"]}`}>
                <img className={styles["img"]} src={img.url} alt={title} loading="lazy" />
                <div className={styles["icon-container"]}>
                    <CameraIcon className={styles["camera-icon"]} />
                </div>
            </div>
            <div className={`${styles["nota-container-text"]}`}>
                <div className={`${styles["grid-card-body-title"]}`}>
                    {summary ? summary.replace(/<\/?p>/g, "") : summary}
                </div>
                <h2>{title}</h2>
            </div>
        </div>
    );
};

export const ModuloContainerGaleriasVerMas = () => {
    return (
        <div className={styles["ver-mas-galerias"]}>
            <a
                href="https://www.ellitoral.com/fotos-hd"
                className={styles["ver-mas-galerias-link"]}
            >
              
            </a>
        </div>
    );
};

export default ModuloContainerGaleriaNotas;
